export default "__VITE_ASSET__CU$N6h4t__"